const SearchExpenseForm = ({ toggleFilters }) => {
  return (
    <>
      {toggleFilters && (
        <div className="rounded bg-gray mb-3 p-3">
          <div className="row">
            <div className="col-lg-3 form-group">
              <label for="orderby" className="form-label fw-bolder">
                Order By
              </label>
              <select name="orderby" id="orderby" className="form-control">
                <option value="ID">ID</option>
                <option value="contact_number">Contact Number</option>
                <option value="cnic">CNIC</option>
                <option value="borrower_name">Name</option>
                <option value="account_number">File#</option>
                <option value="house_number">House#</option>
                <option value="account_status">Account Status</option>
                <option value="account_stage">Account Stage</option>
                <option value="registery">Registry</option>
                <option value="file">File</option>
                <option value="updated_at">Update Time</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="order" className="form-label fw-bolder">
                Order
              </label>
              <select name="order" id="order" className="form-control">
                <option value="ascending">Ascending</option>
                <option value="descending">Descending</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="booking_start_date" className="form-label fw-bolder">
                Booking Start Date
              </label>
              <input
                type="date"
                className="form-control"
                name="booking_start_date"
                id="booking_start_date"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="booking_end_date" className="form-label fw-bolder">
                Booking End Date
              </label>
              <input
                type="date"
                className="form-control"
                name="booking_end_date"
                id="booking_end_date"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="account_status" className="form-label fw-bolder">
                Account Status
              </label>
              <select
                name="account_status"
                id="account_status"
                className="form-control"
              >
                <option value="all">All</option>
                <option value="open">Open</option>
                <option value="cancel">Cancel</option>
                <option value="close">Close</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="is_active" className="form-label fw-bolder">
                Is Active?
              </label>
              <select name="is_active" id="is_active" className="form-control">
                <option value="" selected>
                  All
                </option>
                <option value="active">Active</option>
                <option value="in_active">In-Active</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="search_by" className="form-label fw-bolder">
                Search By
              </label>
              <select name="search_by" id="search_by" className="form-control">
                <option value="" selected>
                  -- Select --
                </option>
                <option value="open">Open</option>
                <option value="cancel">Cancel</option>
                <option value="close">Close</option>
                <option value="close">Close</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="search" className="form-label fw-bolder">
                Search
              </label>
              <input
                type="text"
                className="form-control"
                name="search"
                id="search"
                value=""
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="house_blocks" className="form-label fw-bolder">
                Price Block
              </label>
              <select
                name="house_blocks"
                id="house_blocks"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="a">A Block</option>
                <option value="b">B Block</option>
                <option value="c">C Block</option>
                <option value="d">D Block</option>
                <option value="e">E Block</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="house_size" className="form-label fw-bolder">
                House Size
              </label>
              <select
                name="house_size"
                id="house_size"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="1">1 Marla</option>
                <option value="1.5">1.5 Marla</option>
                <option value="2">2 Marla</option>
                <option value="2.5">2.5 Marla</option>
                <option value="3">3 Marla</option>
                <option value="3.5">3.5 Marla</option>
                <option value="4">4 Marla</option>
                <option value="4.5">4.5 Marla</option>
                <option value="5">5 Marla</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="account_stage" className="form-label fw-bolder">
                Account Stage
              </label>
              <select
                name="account_stage"
                id="account_stage"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="booking">Booking</option>
                <option value="possesion">Possesion</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="is_front" className="form-label fw-bolder">
                Is Front?
              </label>
              <select name="is_front" id="is_front" className="form-control">
                <option value="" selected>
                  -- Select --
                </option>
                <option value="front">Front</option>
                <option value="back">Back</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label for="house_location" className="form-label fw-bolder">
                House Location
              </label>
              <select
                name="house_location"
                id="house_location"
                className="form-control"
              >
                <option value="" selected>
                  -- Select --
                </option>
                <option value="a">A Block</option>
                <option value="b">B Block</option>
                <option value="c">C Block</option>
                <option value="d">D Block</option>
                <option value="e">E Block</option>
              </select>
            </div>
            <div className="col-lg-3 form-group">
              <label
                for="range_file_number"
                className="form-label fw-bolder w-100"
              >
                File Number Range
              </label>
              <input
                type="text"
                className="form-control"
                name="start_file_number"
                id="start_file_number"
                value="0"
                style={{ width: "20%", float: "left" }}
              />
              <input
                type="range"
                className="form-range bg-light m-2"
                id="customRange1"
                style={{ width: "40%", float: "left" }}
              />
              <input
                type="text"
                className="form-control"
                name="end_file_number"
                id="end_file_number"
                value="1250"
                style={{ width: "30%", float: "right" }}
              />
            </div>
            <div className="col-lg-3 form-group">
              <label
                for="range_house_number"
                className="form-label fw-bolder w-100"
              >
                House Number Range
              </label>
              <input
                type="text"
                className="form-control"
                name="start_house_number"
                id="start_house_number"
                value="0"
                style={{ width: "20%", float: "left" }}
              />
              <input
                type="range"
                className="form-range bg-light m-2"
                id="customRange1"
                style={{ width: "40%", float: "left" }}
              />
              <input
                type="text"
                className="form-control"
                name="end_house_number"
                id="end_house_number"
                value="1000"
                style={{ width: "30%", float: "right" }}
              />
            </div>
            <div className="col-lg-3 form-group">
              <label for="" className="d-block form-label fw-bolder">
                Completed Process
              </label>
              <input type="checkbox" name="bf_registery" id="bf_registery" />
              &nbsp;
              <label for="bf_registery" style={{ fontWeight: 400 }}>
                Registry
              </label>
              &nbsp;&nbsp;&nbsp;
              <input type="checkbox" name="bf_file" id="bf_file" /> &nbsp;
              <label for="bf_file" style={{ fontWeight: 400 }}>
                File
              </label>
            </div>
            <div className="clearboth"></div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <button className="btn site_btn text-white me-2">Submit</button>
              <button className="btn site_btn text-white">Reset</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchExpenseForm;
